import { render, staticRenderFns } from "./BaseLogoPartner.vue?vue&type=template&id=315adf48&scoped=true"
import script from "./BaseLogoPartner.vue?vue&type=script&lang=js"
export * from "./BaseLogoPartner.vue?vue&type=script&lang=js"
import style0 from "./BaseLogoPartner.vue?vue&type=style&index=0&id=315adf48&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "315adf48",
  null
  
)

export default component.exports